import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { useValidateUserAndGetDetailsQuery } from "../store/api/orderApi";
import { usePostOrderMutation } from "../store/api/orderApi";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import { months } from '../OrderDetails';


export const  Cart = ({ cartItems, handleRemoveProduct, handleAddProduct, handleCartClearance, handleCheckOut }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const userInfo = useSelector((state) => state.authentication.userInfo);
    const { data: userData } = useValidateUserAndGetDetailsQuery(userInfo.emailId);
    const [postOrder, { isLoading: loadingPost }] = usePostOrderMutation();
    const currentDate = new Date();
    let history = useHistory();

    useEffect(() => {
        window.addEventListener("resize", () => {
            const ismobile = window.innerWidth < 768;
            if (ismobile !== isMobile) setIsMobile(ismobile);
        }, false);
    }, [isMobile]);

    // Sticky header
    const [scroll, setScroll] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 10)
        })
    }, []);


    const totalPrice = cartItems?.reduce(
        (points, item) => points + item.quantity * item.points, 0
    );

    // const totalItems = cartItems?.reduce(
    //     (quantity, item) => quantity + item.quantity,
    // )
    const totalItems = cartItems?.length;
    async function handleCheckOutdata() {
        // console.log(cartItems);
        const month = months[currentDate.getMonth()];
        var jsonData = {
            foodOrderid: "",
            orderFlag: "neworder", //neworder / editorder / cancelorder
            memberUserId: userData.id,
            memberUserName: userInfo.name,
            orderMonthYear: `${month[0].toUpperCase() + month.slice(1).toLowerCase()}${currentDate.getFullYear()}`,//('0' + (currentDate.getMonth() + 1)).slice(-2) + currentDate.getFullYear(),  //mmyyyy Dec2022
            listFoodOrder: []
        }
        jsonData.listFoodOrder = cartItems.map(item => {
            return {
                productId: item.id,
                orderQuantity: item.quantity,
                productName: item.product,
                foodInventoryAggID: item.productInventoryAggID,
            };

        });
        await postOrder(jsonData).unwrap().then(
            () => {
                console.log("Order Placed");
                history.push("/Orders");
                handleCartClearance();

            },
            () => {
                console.log("Order failed")
            }
        )
    }
    return (
        <div>
            {
                loadingPost ?
                    <div className="spinner">
                        <Spinner animation="border" />
                    </div>
                    :
                    <div className="card shopping-cart-body card-no-bg-border">
                        <div className="card-body">

                            <div className="product-contents cart-product-contents clearfix">

                                {cartItems.length === 0 && (
                                    <p>Your cart is empty <Link to='/Product'>Go Back</Link></p>
                                )}
                                {cartItems.length > 0 && (
                                    <>
                                        <p>Total items: {totalItems} </p>
                                    </>
                                )}
                                {/* <!-- PRODUCT --> */}
                                {(cartItems || []).map((item) => (
                                    <div className="row product-row" key={item.id}>
                                        <div className="col-12 col-sm-12 col-md-2 text-center">
                                            <img className="img-responsive img-thumbnail product-preview-img mb-3" src={item.image} alt={item.product} />
                                        </div>
                                        <div className={`col-12 col-sm-12 col-md-6 ${isMobile ? "text-center" : "text-start"}`}>
                                            <h4 className="product-name"><strong>{item.product}</strong></h4>
                                            <p className="product-details">{item.count}</p>
                                            <p className="product-details">Limit: {item.limit}</p>
                                            <p className="product-details"><small>Best used by {item.bestusedby} </small></p>
                                        </div>
                                        <div className={`col-12 col-sm-12 col-md-4 row ${isMobile ? "text-center" : "text-end"}`}>
                                            {/* <div className="col-11 col-sm-11 col-md-11 text-md-right"> */}
                                            <h6><strong> {parseFloat(item.points).toFixed(0)}</strong></h6>
                                            {/* </div> */}
                                            {/* <div className="col-1 col-sm-1 col-md-1 text-right p-0">
                                                <button type="button" className="btn btn-xs p-0 close-icon-btn">
                                                    <i className="fas fa-times" aria-hidden="true"></i>
                                                </button>
                                            </div> */}
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-2 text-center">
                                            <div className="quantity">
                                                <div class="input-group bootstrap-touchspin">
                                                    <span class="input-group-btn">

                                                        {item.quantity > 1 && (
                                                            <>
                                                                <button class="btn btn-outline-secondary bootstrap-touchspin-down" type="button" onClick={() => handleRemoveProduct(item)}>
                                                                    <i className="fas fa-minus"></i>
                                                                </button>
                                                            </>
                                                        )}
                                                        {item.quantity === 1 && (
                                                            <>
                                                                <button class="btn btn-outline-secondary bootstrap-touchspin-down" type="button" onClick={() => handleRemoveProduct(item)}>
                                                                    <i className="fas fa-trash-alt"></i>
                                                                </button>
                                                            </>
                                                        )}
                                                    </span>
                                                    {/* <span class="input-group-addon bootstrap-touchspin-prefix" ></span> */}
                                                    <input type="text" name="" value={item.quantity} class="input-qty form-control text-center" />
                                                    {/* <span class ="input-group-addon bootstrap-touchspin-postfix" style="display: none;"></span> */}
                                                    <span class="input-group-btn" >
                                                        <button class="btn btn-outline-secondary bootstrap-touchspin-up" type="button" onClick={() => (item.quantity + 1 <= item.limit) && handleAddProduct(item)}>
                                                            <i className="fas fa-plus"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}




                                {/* <hr /> */}
                                {/* <!-- END PRODUCT --> */}
                            </div>
                            {cartItems.length > 0 && (
                                <>
                                    <div className="total-amount text-end">
                                        <h6>
                                            <strong><span className="total-heading">Total: </span>
                                                <span className="total-number">
                                                    {/* <span className="text-muted">$</span> */}
                                                    {parseFloat(totalPrice).toFixed(0)}
                                                </span>
                                            </strong>
                                        </h6>
                                    </div>
                                </>
                            )}

                            <div className="clearfix"></div>

                            <div>
                                {
                                    cartItems.length > 0 &&
                                    <>
                                        <div className="checkout-final">
                                            Checkout is final!
                                        </div>
                                        <button className="btn btn-info btn-lg sm-btn-pdg" onClick={() => handleCheckOutdata()}>Checkout</button>

                                    </>
                                }
                                <div className="clear-cart-div">
                                    <NavLink className="btn btn-outline-info btn-sm sm-btn-pdg" exact aria-current="page" to="/Product">
                                        <i class="fas fa-hand-point-left humbrger-menu-icon"></i> Continue shopping
                                    </NavLink>
                                    {
                                        cartItems.length > 0 &&
                                        <div className="btn btn-outline-info btn-sm me-2 sm-btn-pdg clear-cart-btn" onClick={handleCartClearance}>
                                            <i className="fas fa-times me-1"></i>
                                            Clear cart
                                        </div>
                                    }

                                </div>

                            </div>

                        </div>
                    </div>
            }

        </div>
    )
}

export default Cart;